import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import StickyCTA from './components/StickyCTA';

import HomePage from './pages/HomePage';
import BaadtransportPage from './pages/BaadtransportPage';
import ReferencerPage from './pages/ReferencerPage';
import ReferenceDetailPage from './pages/ReferenceDetailPage';
import OmMigPage from './pages/OmMigPage';
import KontaktPage from './pages/KontaktPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <div className="flex flex-col min-h-screen bg-slate-50 text-slate-900 selection:bg-cyan-900 selection:text-white">
      {/* Scroll restoration on route changes */}
      <ScrollToTop />

      {/* Main Header & Navigation */}
      <Navbar />

      {/* Main Page Routes */}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/baadtransport" element={<BaadtransportPage />} />
          <Route path="/baadtransport/" element={<BaadtransportPage />} />
          <Route path="/referencer" element={<ReferencerPage />} />
          <Route path="/referencer/" element={<ReferencerPage />} />
          <Route path="/reference" element={<ReferenceDetailPage />} />
          <Route path="/reference/" element={<ReferenceDetailPage />} />
          <Route path="/om-mig" element={<OmMigPage />} />
          <Route path="/om-mig/" element={<OmMigPage />} />
          <Route path="/kontakt" element={<KontaktPage />} />
          <Route path="/kontakt/" element={<KontaktPage />} />
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>

      {/* Persistent CTA (mobile bottom bar + desktop floating badge) */}
      <StickyCTA />

      {/* Footer */}
      <Footer />
    </div>
  );
}
